<template lang="pug">
    #modal_event.modal-event.estilo-modal.box-login
        .row.title-modal-edit
            .col-lg-12.col-md-12(style="text-align:center")
                h3 Add Charge
                i.fas.fa-times.icon-close-target(@click="closeModal")
        div
            #modalBody.modal-body
                form
                    div 
                        div.campos-detail-modal.row(style="margin: 0;")
                            div.col-lg-6
                                div.form-group.class-inline.row
                                    div.class-campo-icon.col-md-4 Program
                                    div.class-campo-text.col-md-8
                                        span(name="start" id="date") {{ program }}
                            div.col-lg-6
                                div.form-group.class-inline.row
                                    div.class-campo-icon.col-md-4 Client
                                    div.class-campo-text.col-md-8
                                        span(name="start" id="date") {{ client_name }}
                            br
                            br
                            .col-lg-12
                                .row
                                    .col-lg-6
                                        .form-group
                                            div.form-group.class-inline.row
                                                div.class-campo-icon.col-md-4 Concept #[span(v-if="errorConcept" style="color:red") Required]
                                                div.class-campo-text.col-md-8
                                                    select(v-model="concept" class="input-form")
                                                        option(v-for="item in typecharges" :key="item.id" :value="item.id") {{item.description}}
                                                    input.input-form(type="text" v-model="notcharges" v-if="concept == 5" style="margin-top:5px" placeholder="Specify")
                                    .col-lg-6
                                        .form-group
                                            div.form-group.class-inline.row
                                                div.class-campo-icon.col-md-4 Ammount #[span(v-if="errorAmmount" style="color:red") Required]
                                                div.class-campo-text.col-md-8(style="display: inherit;font-size: 15px;") $
                                                    input.input-form(type="text" v-model="ammount" :id="'campo'+2" v-on:blur="validMounthly(2)" @keypress="justNumbers")
                            .col-lg-8
                                .form-group
                                    label Payment Method #[span(v-if="errorPayment" style="color:red") Required]
                                    .row(style="background: #f1f1f1;margin: 0;border-radius: 5px;padding: 7px;")
                                        .col-lg-4(style="display:inherit")
                                            input(id="direct" name="direct" type="radio" value="1" v-model="method_payment" style="margin-top: 4px;margin-right: 4px;")
                                            label(for="direct") Direct Payment
                                        .col-lg-4(style="display:inherit")
                                            input(id="parcial" name="parcial" type="radio" value="2" v-model="method_payment" style="margin-top: 4px;margin-right: 4px;")
                                            label(for="parcial") Parcial
                                        .col-lg-4(style="display:inherit")
                                            input(id="fee" name="fee" type="radio" value="3" v-model="method_payment" style="margin-top: 4px;margin-right: 4px;")
                                            label(for="fee") Fee Charge
                            .col-lg-12.col-md-12(v-if="method_payment == 1 || method_payment == 2")
                                .form-group.row                                    
                                    .col-md-8
                                        label Type Payment #[span(v-if="errorType" style="color:red") Required]
                                        .row(style="background: #f1f1f1;margin: 0;border-radius: 5px;padding: 7px;")
                                            .col-lg-4(style="display:inherit")
                                                input(style="margin-top: 5px;margin-right: 2px;" type="radio" name="method" id="card" v-model="type_payment" value="1")
                                                label(for="card" ) Credit Card
                                            .col-lg-4(style="display:inherit")
                                                input( style="margin-top: 5px;margin-right: 2px;" type="radio" name="method" id="cash" v-model="type_payment" value="2")
                                                label(for="cash" ) Others                                    
                                    .col-lg-4(v-if="method_payment == 2")                                        
                                        label Ammount Partial #[span(v-if="errorAmmountPartial" style="color:red") Required]
                                        div(style="display: flex;font-size: 15px;")
                                            span(style="margin-right: 5px") $ 
                                            input.input-form(type="text" v-model="ammount_partial" style="height: 33px;" :id="'campo'+1" v-on:blur="validpartial(1)" @keypress="justNumbers")
                            .col-lg-6.col-md-6(v-if="type_payment == 2 && method_payment !=3")
                                .form-group
                                    label Type #[span(v-if="errorType2" style="color:red") Required]
                                    select(v-model="types" class="input-form")
                                        option(value="1") Cash
                                        option(value="2") Check
                                        option(value="3") Money Order
                            .col-lg-6.col-md-6(v-if="type_payment == 2 && method_payment !=3")
                                .form-group
                                    label Serial Number #[span(v-if="errorSerial" style="color:red") Required]
                                        input.input-card.input-form(v-model="specify" style="background: #f1f1f1 !important")                                                                
                            .col-lg-12.col-md-12(v-if="(method_payment == 1 || method_payment == 2) & type_payment == 1") 
                                .col-lg-12.col-md-12(:style=" cards != null ? cards.length > 3 ? 'height: 120px;margin-bottom:15px;margin-top: 15px;overflow-y: auto;padding-right: 0;padding-left: 0;':'margin-top: 15px;padding-right: 0;padding-left: 0;':'margin-top: 15px;padding-right: 0;padding-left: 0;'")
                                label #[span(v-if="errorCard" style="color:red") Required]
                                    table.table
                                        tbody(style="border: 1px solid #ccc;")
                                            tr(style="background: #f1f1f1;color: #999999;")
                                                th 
                                                th Card Holder Name
                                                th Card Number
                                                th MM
                                                th YY
                                                th CVC
                                            tr(v-for="(card, index) in cards" :key="index" v-show="card.cardnumber != null")
                                                td 
                                                    input(type="radio" :value="card.id" :name="'card'+card.id" v-model="card_id")
                                                td(style="color: #9b9b9b;text-transform: capitalize") {{card.cardholdername}}
                                                td(style="color: #9b9b9b;") {{'XXXX-XXXX-XXXX-'+card.cardnumber}}
                                                td(style="color: #9b9b9b;") {{card.card_expi_month}}
                                                td(style="color: #9b9b9b;") {{card.card_expi_year}}
                                                td(style="color: #9b9b9b;") {{card.cardsecuritycode != null ?  card.cardsecuritycode.length == 3 ? 'XX'+card.cardsecuritycode.substr(2) : 'XXX'+card.cardsecuritycode.substr(3) : ''}}
                                .col-lg-12.col-md-12(style="text-align: right" v-if="method_payment == 1 || method_payment == 2" )
                                    a(@click="createcard" class="btn class-button-green" style="width:80px;color:white") #[img(:src="'/images/icon-add.png'" style="margin-right: 5px;width: 18%;margin-top: -3px;")] ADD
                                        span(v-if="CAerror" style="color:red;position: absolute;left: 15px;top: 25px;") Required  
                                .col-lg-12.col-md-12(v-if="errosList")
                                    .form-group(style="color:red")
                                        span(v-if="responseCode == 1") Approved
                                        span(v-if="responseCode == 2") Declined
                                        span(v-if="responseCode == 3") Error
                                        span(v-if="responseCode == 4") Held for Review
                                        ul
                                            li(v-for="(items , index) in errosAutorize" :key="index") {{items.errorText}}
                                .col-lg-12.col-md-12(v-if="messageList")
                                    .form-group(style="color:green")
                                        span(v-if="responseCode == 1") Approved
                                        span(v-if="responseCode == 2") Declined
                                        span(v-if="responseCode == 3") Error
                                        span(v-if="responseCode == 4") Held for Review
                                        ul
                                            li(v-for="(items , index) in messageAutorize" :key="index") {{items.description}}
            .modal-footer
                button.btn.btn-success.btn-color-green( @click="saveCharge" type="button" style="font-size: 13px;padding: 6px;height: 35px;") #[i.fas.fa-save] SAVE                
        modal-card-create(v-if="createmodal" :idlead="this.lead_id" @new="addCard" @click="closedModalCar" style="z-index:99 !important" )

</template>


<script>
export default {
    props:[ 'nameProgram' ,'nameClient' ,'lead_id','id','account','session','cantcards'],
    data() {
        return {
            program: this.nameProgram,
            client_name:this.nameClient,
            method_payment: '',
            cards: JSON.parse(this.cantcards),
            CAerror:false,
            createmodal: false,
            type_payment:'',
            specify:'',            
            concept:'',
            ammount:'',
            ammount_partial:'',
            card_id:'',
            types:'',
            errorConcept:false,
            errorAmmount:false,
            errorPayment:false,
            errorType:false,
            errorCard:false,
            errorType2:false,
            errorSerial:false,
            errorAmmountPartial:false,
            errosAutorize: [],
            messageAutorize: [],
            errosList: false,
            messageList: false,
            responseCode: '',
            typecharges:[],
            notcharges:''
        }
    },
    mounted() {        
    },
    methods: {
        validMounthly(id){
            this.ammount = this.globalFunction(id)
        },
        validpartial(id){
            this.ammount_partial = this.globalFunction(id)
        },
        globalFunction(id){
            var x = document.getElementById('campo'+id).value            
            if(x.length > 0){                
                if(x.indexOf('.') != -1){ 
                    var numw = x.replace(/,/gi, "");
                    var dec = numw.split('.')
                    var num = dec[0].split(/(?=(?:\d{3})+$)/).join(",");
                    num = num+'.'+dec[1]
                    
                }else{
                    var numw = x.replace(/,/gi, "");
                    var num = numw.split(/(?=(?:\d{3})+$)/).join(",");
                    num = num+'.00'
                }
                return num
            }else{
                return x
            }
        },
        justNumbers: function (event) {
            var charCode = window.event ? event.which : event.keyCode;
            var RE = /^\d*(\.\d{1})?\d{0,1}$/;
            if (charCode != 46 && charCode > 31 
            && (charCode < 48 || charCode > 57)) {
                //Usando la definición del DOM level 2, "return" NO funciona.
                event.preventDefault();
            }
        },
        closeModal(){
            this.$emit('click',false)
        },
        createcard(){

        },
        createcard(){
            this.createmodal = true;
            var x = document.getElementById('modal_event')            
            x.classList.add('preloader-new')
        },
        addCard(cards) {
            this.cards = cards;
        },
        closedModalCar(click){
            this.createmodal = false
            var x = document.getElementById('modal_event')
            x.classList.remove('preloader-new')
        },
        saveCharge(){
            if(this.concept == '' && this.ammount == '' && this.method_payment == ''){
                this.errorConcept = true
                this.errorAmmount = true
                this.errorPayment = true
            }else if(this.concept == '' && this.ammount == '' && this.method_payment != ''){
                this.errorConcept = true
                this.errorAmmount = true
                this.errorPayment = false
            }else if(this.concept == '' && this.ammount != '' && this.method_payment == ''){
                this.errorConcept = true
                this.errorAmmount = false
                this.errorPayment = true
            }else if(this.concept == '' && this.ammount != '' && this.method_payment != ''){
                this.errorConcept = true
                this.errorAmmount = false
                this.errorPayment = false
            }else if(this.concept != '' && this.ammount == '' && this.method_payment == ''){
                this.errorConcept = false
                this.errorAmmount = true
                this.errorPayment = true
            }else if(this.concept != '' && this.ammount != '' && this.method_payment == ''){
                this.errorConcept = false
                this.errorAmmount = false
                this.errorPayment = true
            }else if(this.concept != '' && this.ammount == '' && this.method_payment != ''){
                this.errorConcept = false
                this.errorAmmount = true
                this.errorPayment = false
            }else if(this.concept != '' && this.ammount != '' && this.method_payment != ''){
                this.errorConcept = false
                this.errorAmmount = false
                this.errorPayment = false
                if(this.method_payment == 3){
                    this.axiospost()
                }else if(this.method_payment == 1){
                    if(this.type_payment == ''){
                        this.errorType = true
                    }else{                        
                        this.errorType = false
                        if(this.type_payment == 1){
                            if(this.card_id == ''){
                                this.errorCard = true
                            }else{
                                this.errorCard = false
                                this.axiospost()
                            }
                        }else if(this.type_payment == 2){
                            if(this.types == '' && this.specify == ''){
                                this.errorType2 = true
                                this.errorSerial = true
                            }else if(this.types != '' && this.specify == ''){
                                this.errorType2 = false
                                this.errorSerial = true
                            }else if(this.types == '' && this.specify != ''){
                                this.errorType2 = true
                                this.errorSerial = false
                            }else if(this.types != '' && this.specify != ''){
                                this.errorType2 = false
                                this.errorSerial = false
                                this.axiospost()
                            }
                        }
                    }
                }else if(this.method_payment == 2){
                    if(this.type_payment == '' && this.ammount_partial == ''){
                        this.errorType = true
                        this.errorAmmountPartial = true
                    }else if(this.type_payment != '' && this.ammount_partial == ''){
                        this.errorType = false
                        this.errorAmmountPartial = true
                    }else if(this.type_payment == '' && this.ammount_partial != ''){
                        this.errorType = true
                        this.errorAmmountPartial = false
                    }else if(this.type_payment != '' && this.ammount_partial != ''){
                        this.errorType = false
                        this.errorAmmountPartial = false
                        if(this.type_payment == 1){
                            if(this.card_id == ''){
                                this.errorCard = true
                            }else{
                                this.errorCard = false
                                this.axiospost()
                            }
                        }else if(this.type_payment == 2){
                            if(this.types == '' && this.specify == ''){
                                this.errorType2 = true
                                this.errorSerial = true
                            }else if(this.types != '' && this.specify == ''){
                                this.errorType2 = false
                                this.errorSerial = true
                            }else if(this.types == '' && this.specify != ''){
                                this.errorType2 = true
                                this.errorSerial = false
                            }else if(this.types != '' && this.specify != ''){
                                this.errorType2 = false
                                this.errorSerial = false
                                this.axiospost()
                            }
                        }
                    }
                }
            }
        },
        axiospost(){
            var x = document.getElementById('modal_event')
            x.classList.add('preloader-new')
            swal.fire({
                title: 'Add Charge',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ab9220',
                cancelButtonColor: '#8f9194',
                confirmButtonText: 'Yes'
                }).then((result) => {
                    if (result.value) {
                        var x = document.getElementById('app')
                        x.classList.add('preloader')
                        axios.post('/savecharge',{
                            id: this.id,
                            account: this.account,
                            concept: this.concept,
                            ammount: this.ammount.replace(',', ""),
                            ammount_partial: this.method_payment == 1 ? this.ammount.replace(',', "") : this.ammount_partial.replace(',', ""),
                            method_payment: this.method_payment,
                            card_id: this.card_id,
                            type_payment: this.type_payment,
                            type: this.type_payment != 1 ? this.types : 0,
                            specify: this.specify,
                            user_id:this.session,
                            notcharges:this.notcharges
                        })
                        .then(response => {                            
                            if(response.status == 200 && response.data.status == 200) {                                
                                x.classList.remove('preloader')
                                if(response.data.transaction != ""){
                                    this.messageAutorize = response.data.transaction.messages.message
                                    this.responseCode = response.data.transaction.responseCode 
                                }                                
                                this.messageList = true
                                this.errosList = false
                                swal.fire({
                                    type: 'success',
                                    title: 'Operation Finish'
                                }).then( (res) => {
                                    if(res){
                                        this.$emit('dato',true)
                                        this.$emit('click',false)
                                        }
                                    }); 
                            }else if(response.status == 200 && response.data.status == 500){
                                if(response.data.transaction.errors){
                                    this.errosAutorize = response.data.transaction.errors.error
                                    this.responseCode = response.data.transaction.responseCode
                                    this.messageList = false
                                    this.errosList = true
                                }else{
                                    this.messageAutorize = response.data.transaction.messages.message
                                    this.responseCode = response.data.transaction.responseCode 
                                    this.messageList = true
                                    this.errosList = false
                                }
                            }
                        }).catch(error => {
                            if(error.response.status == 500 ) {
                                this.errosAutorize = response.data.transaction.errors.error
                                this.responseCode = response.data.transaction.responseCode
                                this.errosList = true
                            }
                        })
                    }
                })
        },
        getTypecharges(){
            axios.get('/api/typecharges')
            .then(response => {
                this.typecharges =  response.data 
            });
        },
    },
    created() {
        this.getTypecharges()
    },
}
</script>